import axios from "axios";

const server = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export class TilopayFetchAPI {
  // Pide al servidor el intento de pago y el token del SDK. El monto sale del calculo oficial, no del navegador.
  static async createSession({ calculation_id, branchoffice_id, branch_machine_id, client_id }) {
    return server("/tilopay/session", {
      method: "post",
      data: { calculation_id, branchoffice_id, branch_machine_id, client_id },
    });
  }

  // Estado real del pago (el servidor consulta a Tilopay).
  static async getStatus(orderNumber) {
    return server(`/tilopay/status/${encodeURIComponent(orderNumber)}`, { method: "get" });
  }
}
